var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Graduation_hat",
    "data-name": "Graduation hat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.296,
    height: 31.29,
    viewBox: "0 0 47.296 31.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "studio",
    "data-name": "Path 778",
    d: "M45.563,36.662A2,2,0,0,0,47.9,34.689V22.817a1,1,0,0,0-.633-.93L27.088,13.921A10,10,0,0,0,19.553,14L1.238,21.671a1,1,0,0,0,.034,1.858l7.835,2.947V34.62c0,4.64,7.412,6.753,14.3,6.753s14.3-2.113,14.3-6.753V26.213L43.9,23.736V34.582A2.075,2.075,0,0,0,45.563,36.662Zm-24.09-19.13a5,5,0,0,1,3.768-.039l6.835,2.7H23.407a2,2,0,1,0,0,4h8.584l-6.728,2.69a5,5,0,0,1-3.617.038l-11.9-4.475ZM33.709,34.6c-.2.765-3.662,2.776-10.3,2.776S13.3,35.362,13.107,34.62V27.981l6.768,2.545a10,10,0,0,0,7.234-.075l6.6-2.638Z",
    transform: "translate(-0.624 -13.222)",
    fill: "#3166b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "studio",
    "data-name": "Path 779",
    d: "M45.92,38.069a2,2,0,0,0-2,2v2.443a2,2,0,0,0,4,0V40.069A2,2,0,0,0,45.92,38.069Z",
    transform: "translate(-0.624 -13.222)",
    fill: "#333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationHat);
export default __webpack_public_path__ + "static/media/GraduationHat.4b5aa8f4081a2e39fc923eee9bfe5a56.svg";
export { ForwardRef as ReactComponent };